/**
 * MUI Dialog / Modal component overrides.
 */
import { Components, Theme } from "@mui/material/styles";

export const dialogOverrides: Pick<Components<Theme>, "MuiModal"> = {
  MuiModal: {
    styleOverrides: {
      root: ({ theme }) => ({
        ".MuiPaper-root": {
          margin: 24,
          borderRadius: "8px",
          [theme.breakpoints.down("sm")]: {
            borderRadius: "4px"
          }
        },
        ".MuiDialogTitle-root": {
          paddingTop: 16
        },
        ".MuiDialogContent-root": {
          paddingBottom: 16
        }
      })
    }
  }
};
